<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card">
				<Toolbar class="p-mb-4">
					<template v-slot:left>
						<Button label="新建" icon="pi pi-plus" class="p-button-success p-mr-2" @click="$router.push({name: 'submissioncreate', params: { id: 'new' }})" />
					</template>

					<!-- <template v-slot:right>
						<span class="p-input-icon-left">
							<i class="pi pi-search" />
							<InputText v-on:keyup.enter="basicSearch" v-model="searchKeyword" placeholder="检索" />
						</span>
					</template> -->
				</Toolbar>

				<DataTable :value="proposals" dataKey="_id" :paginator="true" :rows="25" :rowHover="true" showGridlines 
							paginatorPosition="both" v-model:first="currentPageFirstIndex"
							paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" :rowsPerPageOptions="[5,10,25,50,100]"
							currentPageReportTemplate="Showing {first} to {last} of {totalRecords} proposals" responsiveLayout="stack"
							:rowClass="rowClass">
					<template #header>
						<div style="text-align: center">
							<h4 class="p-m-0">个人提案</h4>
						</div>
					</template>

					<Column header="序号" headerStyle="width: 6em; text-align: left">
						<template #body="slotProps">
							<span style="color: RGB(33,150,243)">{{currentPageFirstIndex + slotProps.index + 1}}</span>
						</template>
					</Column>
					<Column header="束流申请编号">
						<template #body="slotProps">
							{{slotProps.data.number}}
						</template>
					</Column>
					<Column header="实验名称">
						<template #body="slotProps">
							<div style="cursor:pointer" @click="$router.push({ name: 'proposalinfo', params: { id: slotProps.data._id } })">{{slotProps.data.experimentName}}</div>
						</template>
					</Column>
					<Column header="实验负责人">
						<template #body="slotProps">
							{{slotProps.data.ownerName}}
						</template>
					</Column>
					<Column header="单位">
						<template #body="slotProps">
							{{slotProps.data.ownerOrganization}}
						</template>
					</Column>
					<Column header="实验开始时间">
						<template #body="slotProps">
							{{showDateTime(slotProps.data.expectedDate)}}
						</template>
					</Column>
					<Column header="申请束流时间（小时）">
						<template #body="slotProps">
							{{slotProps.data.requestBeamTime}}
						</template>
					</Column>
					<Column header="状态" bodyStyle="text-align: center">
						<template #body="slotProps">
							<div :style="{'background-color': showProposalStatusColor(slotProps.data), 'line-height': '2em'}">
								{{ showProposalStatus(slotProps.data) }}
							</div>
						</template>
					</Column>
					<Column header="操作">
						<template #body="slotProps">
							<Button icon="pi pi-pencil" :disabled="!canEditProposal(slotProps.data)" v-tooltip.top="'编辑'" class="p-button-rounded p-button-success p-mr-2" @click="$router.push({ name: 'submissioncreate', params: { id: slotProps.data._id } })" />
							<Button icon="pi pi-trash" :disabled="!canDeleteProposal(slotProps.data)" v-tooltip.top="'删除'" class="p-button-rounded p-button-danger p-mr-2" @click="confirmDeleteProposal(slotProps.data)" />
							<Button icon="fa fa-paper-plane-o" :disabled="!canSummarizeProposal(slotProps.data)" v-tooltip.top="'总结'" class="p-button-rounded p-button-warning p-mr-2" @click="$router.push({ name: 'summarize', params: { id: slotProps.data._id } })" />
							<Button icon="fa fa-info" :disabled="false" v-tooltip.top="'详情'" class="p-button-rounded p-button-primary p-mr-2" @click="showProposalInfo(slotProps.data)" />
							<Button icon="pi pi-file-pdf" :disabled="!canGenerateApplicationForm(slotProps.data)" v-tooltip.top="'申请表'" class="p-button-rounded p-button-help p-mr-2" @click="createPdf(slotProps.data)" />
							<Button icon="fa fa-line-chart" :disabled="!canGenerateExperimentRecord(slotProps.data)" v-tooltip.top="'实验记录'" class="p-button-rounded p-button-secondary" @click="createExperimentSummary(slotProps.data)" />
						</template>
					</Column>
				</DataTable>

				<Dialog v-model:visible="deleteProposalDialog" :style="{width: '450px'}" header="消息确认" :modal="true">
					<div>
						<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2em; color: orange; vertical-align: middle;" />
						<span style="color: orange">确定要删除如下提案吗?</span>
						<div v-if="proposal" style="text-indent: 3em;">实验名称：{{ proposal.experimentName }}</div>
					</div>
					<template #footer>
						<Button label="取消" icon="pi pi-times" class="p-button-text" @click="deleteProposalDialog = false"/>
						<Button label="确定" icon="pi pi-check" class="p-button-primary" @click="deleteProposal" />
					</template>
				</Dialog>

				<Dialog v-model:visible="showProposalInfoDialog" :style="{width: '80%'}" header="提案信息" :modal="true" :maximizable="true">
					<ProposalData :proposal="proposal" />
					<template #footer>
						<Button label="关闭" icon="pi pi-times" class="p-button-primary" @click="showProposalInfoDialog = false"/>
					</template>
				</Dialog>

				<Dialog header="实验总结" v-model:visible="proposalReportDialogDisplay" :style="{width: '30vw'}"  :modal="true" :contentStyle="{ overflow: 'visible' }">
					<div class="p-grid">
						<div class="p-col-12">
							<div><label style="margin-right: 0.5em"><span style="color: red">*</span> 开始日期：</label><Calendar class="procurement-info-dropdown" v-model="startDate" :showIcon="true" dateFormat="yy-mm-dd" /></div>
						</div>
						<div class="p-col-12">
							<div><label style="margin-right: 0.5em"><span style="color: red">*</span> 结束日期：</label><Calendar class="procurement-info-dropdown" v-model="endDate" :showIcon="true" dateFormat="yy-mm-dd" /></div>
						</div>
						<div class="p-col-12">
							<div style="margin-top: 0.2em; margin-bottom: 0.5em;">
								<label style="margin-right: 1.5em"><span style="color: red">*</span> 实验报告：</label>
								<a v-if="selectedAttachment && selectedAttachment.name" :href="buildReportFileUrl(proposal._id)" target="_blank" v-tooltip.top="'点击预览'">
									<i class="fa fa-file-pdf-o fa-lg" style="color: red; cursor: pointer; margin-left: 5px; margin-right: 5px"></i>
									<span class="procurement-info-item">{{ selectedAttachment.name }}</span>
								</a>
								<span v-else class="procurement-info-item">无</span>
							</div>
						</div>
						<div class="p-col-12">
							<FileUpload name="file" :url="buildReportFileUrl(proposal._id)" accept=".pdf" :maxFileSize="10000000" chooseLabel="选择" uploadLabel="上传" cancelLabel="取消" @upload="onUpload" @error="onError" @before-send="onBeforeSend" :auto="true" >
								<template #empty>
									<p>可将文件拖拽至此处上传。</p>
								</template>
							</FileUpload>
						</div>
					</div>
					<template #footer>
						<Button label="取消" icon="pi pi-times" style="margin-right: 1em" class="p-button-text" @click="proposalReportDialogDisplay=false" />
						<Button label="提交" icon="pi pi-check" class="p-button-raised p-button-primary" @click="reportProposal" />
					</template>
				</Dialog>

			</div>
		</div>
	</div>

</template>

<script>
import AuthenticationService from '../service/AuthenticationService';
import ProposalService from '../service/ProposalService';
import ProposalData from './ProposalData';
const moment = require('moment');
const dateFormat = require('dateformat');

export default {
	data() {
		return {
			proposals: null,
			deleteProposalDialog: false,
			showProposalInfoDialog: false,
			proposalReportDialogDisplay: false,
			proposal: {},
			filters: {},
			selectedAttachment: {},
			searchKeyword: null,
			submitted: false,
			currentPageFirstIndex: 0,
		}
	},
	proposalService: null,
	authenticationService: null,
	created() {
		this.proposalService = new ProposalService();
		this.authenticationService = new AuthenticationService();
	},
	mounted() {
		this.loadData();
	},
	methods: {
		loadData() {
			this.proposalService.findSelfProposals()
			.then(data => {
				this.proposals = data;
			}).catch(error => {
				if(error.response) {
					this.$toast.add({ severity: 'error', summary: '提案加载失败', detail: error.response.data.message });
				} else {
					this.$toast.add({ severity: 'error', summary: '提案加载失败', detail: error.message });
				}
			})
		},
		deleteProposal() {
			// let loader = this.$loading.show();
			this.proposalService.deleteProposal(this.proposal._id)
			.then((proposal) => {
				this.deleteProposalDialog = false;
				this.$toast.add({severity: 'info', summary: '提案删除成功', detail: `实验名称: ${proposal.experimentName}\n实验负责人: ${proposal.ownerName}`, life: 5000});
				this.loadData();
			}).catch(error => {
				// loader.hide();
				if(error.response) {
					this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.response.data.message });
				} else {
                    this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.message });
				}
			});
		},
		reportProposal() {
			console.log(this.proposal);
            if(!this.proposal.startDate) {
              this.$toast.add({ severity: 'error', summary: '更新提案失败', detail: '实验开始日期不能为空' });
              return;
            }
			if(!this.proposal.endDate) {
              this.$toast.add({ severity: 'error', summary: '更新提案失败', detail: '实验结束日期不能为空' });
              return;
            }

            let loader = this.$loading.show();
            this.proposalService.reportProposal(this.proposal)
            .then((proposal) => {
                this.loadData();
                loader.hide();
                this.$toast.add({severity: 'info', summary: '提案信息更新成功', detail: `实验题目: ${proposal.experimentName}`, life: 5000});
                this.proposalReportDialogDisplay = false;
            }).catch(error => {
                loader.hide();
                if(error.response) {
                    this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.response.data.message });
                } else {
                    this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.message });
                }
            });
        },
		buildReportFileUrl(id) {
            return this.proposalService.reportFileUrl(id);
		},
		showProposalInfo(proposal) {
			this.proposal = proposal;
			this.showProposalInfoDialog=true
		},
		confirmDeleteProposal(proposal) {
			this.proposal = proposal;
			this.deleteProposalDialog = true;
		},
		proposalReportClick(proposal) {
			this.proposal = {_id: proposal._id};
			this.selectedAttachment = proposal.attachment;
			this.proposalReportDialogDisplay=true;
			console.log(this.proposal);
		},
		basicSearch() {
			// let loader = this.$loading.show();
			if(this.searchKeyword != null && this.searchKeyword.length > 0) {
                this.filters.search = this.searchKeyword;
			} else {
				this.filters.search = null;
			}
			this.proposalService.findProposals(this.filters)
			.then(proposals => { 
				this.proposals = proposals; 
				// loader.hide();
				// this.$toast.add({severity: 'info', summary: '检索已完成', life: 3000});
			}).catch(error => {
				// loader.hide();
				if(error.response) {
					this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.response.data.message });
				} else {
					this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.message });
				}
			});
		},
		showProposalStatus(value) {
            return this.proposalService.showProposalStatus(value);
        },
        showProposalStatusColor(value) {
            return this.proposalService.showProposalStatusColor(value);
        },
		createPdf(data) {
			this.proposalService.createPdf(data);
		},
		createExperimentSummary(data) {
			this.proposalService.createExperimentSummary(data);
		},
		canEditProposal(proposal) {
            return this.proposalService.canEditProposal(proposal);
        },
		canDeleteProposal(proposal) {
            return this.proposalService.canDeleteProposal(proposal);
        },
		canSummarizeProposal(proposal) {
            return this.proposalService.canSummarizeProposal(proposal);
        },
		canGenerateApplicationForm(proposal) {
            return this.proposalService.canGenerateApplicationForm(proposal);
        },
		canGenerateExperimentRecord(proposal) {
            return this.proposalService.canGenerateExperimentRecord(proposal);
        },
		onBeforeSend(event) {
			this.loader = this.$loading.show();
			let auth = this.authenticationService.authHeaderXhr();
			let xmlhttp = event.xhr;
			xmlhttp.setRequestHeader(auth.key, auth.value);
			console.log(auth);
		},
		onUpload(event) {
            let fileName = event.files && event.files[0] ? event.files[0].name : '';
			this.$toast.add({severity: 'info', summary: '文件上传成功', detail: fileName, life: 3000});
            this.loader.hide();

            this.proposalService.findSingleProposal(this.proposal._id)
            .then(proposal => { 
                this.selectedAttachment = proposal ? proposal.attachment : null;
            }).catch(error => {
                if(error.response && error.response.data)
                    this.$toast.add({ severity: 'error', summary: '文件信息加载失败', detail: `${error.message} ---- ${error.response.data.message}` });
                else 
                    this.$toast.add({ severity: 'error', summary: '文件信息加载失败', detail: error.message });
            });

            // this.loadData();
		},
		onError(event) {
			if(event.xhr && event.xhr.response) {
				let response = JSON.parse(event.xhr.response);
				this.$toast.add({severity: 'error', summary: '文件上传失败', detail: `${response.message}`});
			}
			else 
				this.$toast.add({severity: 'error', summary: '文件上传失败', detail: ''});

			this.loader.hide();
		},
		rowClass(data) {
            if (!data) return
			let dateNow = new Date();

			if(data.updatedAt) {
				let updatedAt = new Date(data.updatedAt);
				if (updatedAt.getTime() > dateNow.getTime() - 3 * 60 * 1000) 
					return 'updated-row';
			}

			if(data.createdAt) {
				let createdAt = new Date(data.createdAt);
				if (createdAt.getTime() > dateNow.getTime() - 3 * 60 * 1000) 
					return 'updated-row';
			}

			return null;
        },
		showDate(value) {
            return dateFormat(value, "yyyy-mm-dd");
        },
        showTime(value) {
            return dateFormat(value, "HH:MM");
        },
        showDateTime(value) {
            return dateFormat(value, "yyyy-mm-dd HH:MM");
        },
	},
	components: {
        'ProposalData': ProposalData,
	},
	computed: {
        startDate: {
            get() {
                return this.proposal.startDate ? new Date(this.proposal.startDate) : null;
            },
            set(value) {
                this.proposal.startDate = moment(value).format("YYYY-MM-DD");
            }
        },
		endDate: {
            get() {
                return this.proposal.endDate ? new Date(this.proposal.endDate) : null;
            },
            set(value) {
                this.proposal.endDate = moment(value).format("YYYY-MM-DD");
            }
        },
        loggedIn() {
            return this.$store.state.authentication.status.loggedIn;
        },
        userInfo() {
            return this.$store.state.authentication.user;
        }
    },
}
</script>

<style scoped lang="scss">
	.table-header {
		display: flex;
		justify-content: space-between;
	}

	.confirmation-content {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
		.p-button {
			margin-bottom: .25rem;
		}
	}

	::v-deep .updated-row {
		background-color: moccasin !important;
	}
</style>
